document.addEventListener('DOMContentLoaded', function () {
  const stickyBar = document.querySelector('#global-sticky-add-to-cart');
  const stickyButton = document.querySelector('#global-sticky-add-to-cart-button');

  if (!stickyBar || !stickyButton) return;

  const productForm = document.querySelector(
    'product-form form[data-type="add-to-cart-form"]'
  );

  if (!productForm) return;

  const originalButton = productForm.querySelector('button[name="add"]');

  if (!originalButton) return;

  function hasScrolledPastOriginalButton() {
    return originalButton.getBoundingClientRect().bottom < 0;
  }

  function checkButtonVisibility() {
    stickyBar.classList.toggle('is-visible', hasScrolledPastOriginalButton());
  }

  checkButtonVisibility();
  window.addEventListener('load', checkButtonVisibility);
  window.addEventListener('scroll', checkButtonVisibility, { passive: true });
  window.addEventListener('resize', checkButtonVisibility);

  if ('IntersectionObserver' in window) {
    const visibilityObserver = new IntersectionObserver(checkButtonVisibility);
    visibilityObserver.observe(originalButton);
  }

  stickyButton.addEventListener('click', function () {
    if (!originalButton.disabled) {
      originalButton.click();
    }
  });

  function syncButton() {
    stickyButton.disabled = originalButton.disabled;

    const originalText = originalButton.querySelector('span');
    const stickyText = stickyButton.querySelector('span');

    if (originalText && stickyText) {
      stickyText.textContent = originalText.textContent.trim();
    }
  }

  syncButton();

  const observer = new MutationObserver(syncButton);

  observer.observe(originalButton, {
    attributes: true,
    childList: true,
    subtree: true
  });
});
